import { motion } from "motion/react";
import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  children: ReactNode;
  isStaticFirst?: boolean;
};

export default function TransitionWrapper({ className, isStaticFirst, children }: Props) {
  return (
    <motion.div
      initial={isStaticFirst ? false : { opacity: 0, translateX: "100%" }}
      animate={{ opacity: 1, translateX: "none" }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={cn("flex flex-col size-full", className)}
    >
      {children}
    </motion.div>
  );
}
